import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Bath(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.017 2.936A3.093 3.093 0 0115.905.95h.708A3.487 3.487 0 0120.1 4.437v7.69a.752.752 0 01-.017.16v1.382c0 1.707-1.009 3.156-2.46 3.886.3.407.479.91.479 1.456h-1.5a.95.95 0 00-.95-.95H5.607a.95.95 0 00-.95.95h-1.5c0-.51.156-.983.422-1.376-1.541-.7-2.628-2.194-2.628-3.966v-2.602c0-.121-.117-.291-.352-.291H.05v-1.5h.549c.982 0 1.852.762 1.852 1.79v.031h16.132v-1.071c0-.054.006-.107.017-.158V4.437c0-1.098-.89-1.987-1.987-1.987h-.708a1.59 1.59 0 00-1.322.706c.55.209 1.058.56 1.466 1.052l.82.989a1.5 1.5 0 01-1.154 2.457h-4.8a1.5 1.5 0 01-1.154-2.457l.82-.99a3.531 3.531 0 012.436-1.271zM2.451 13.669v-1.072h16.132v1.072c0 1.557-1.35 2.892-3.107 2.892H5.558c-1.757 0-3.107-1.335-3.107-2.892zm13.264-7.515h-4.8l.82-.988c.182-.22.397-.39.632-.512a2.062 2.062 0 011.896 0c.235.122.45.293.632.512l.82.988z"
  }));
}

export { Bath };
//# sourceMappingURL=Bath.js.map